import axiosInstance from '../libs/axiosInstance';

export const getQuizzes = async ({ topic_id = null }) => {
  const response = await axiosInstance.get(`/question_bank/public/topics/${topic_id}/quizzes/`);
  return response.data;
};

// used to get question while starting a quiz session
export const getQuizWithQuestions = async (quizId, sessionId = null) => {
  const response = await axiosInstance.get(`/question_bank/public/quizzes/${quizId}/`, {
    params: sessionId ? { session_id: sessionId } : {}
  });
  return response.data;
};

export const getQuiz = async (quizId, sessionId = null) => {
  const response = await axiosInstance.get(`/question_bank/public/quizzes/${quizId}/basic/`, {
    params: sessionId ? { session_id: sessionId } : {}
  });
  return response.data;
};

// verify webcam face image against student ID card image
export const verifyIdentity = async (quizId, webcamFile) => {
  const formData = new FormData();
  formData.append("webcam_image", webcamFile);

  const response = await axiosInstance.post(`/quiz-session/quizzes/${quizId}/verify-identity/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 2 * 60 * 1000, // 2 minutes timeout for face verification
  });
  return response.data;
};

export const getNextQuiz = async (topicId) => {
  const response = await axiosInstance.get(`/question_bank/public/topics/${topicId}/next-quiz/`);
  return response.data;
};

